// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function ChannelBadge(props) {
  var onClick = props.onClick;
  var source = props.source;
  var icons = Belt_MapString.fromArray([
        [
          "Shopify",
          Image$ReactHooksTemplate.shopify
        ],
        [
          "Freshdesk",
          Image$ReactHooksTemplate.freshdesk
        ],
        [
          "Freshchat",
          Image$ReactHooksTemplate.freshchat
        ],
        [
          "Pragma",
          Image$ReactHooksTemplate.pragma
        ]
      ]);
  var activeClass = props.isActive ? "bg-bleudefrance text-white" : "bg-gray-200 text-gray-700";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("span", {
                    children: [
                      JsxRuntime.jsx("span", {
                            children: source,
                            className: "ml-1"
                          }),
                      JsxRuntime.jsx("img", {
                            className: "w-5 h-5 ml-1",
                            alt: source,
                            src: Belt_MapString.getWithDefault(icons, source, Image$ReactHooksTemplate.avatar)
                          }),
                      JsxRuntime.jsx("span", {
                            children: "(" + String(props.count) + ")",
                            className: "ml-1"
                          })
                    ],
                    className: "px-3 py-1 rounded-full select-none hover:bg-gray-300 flex items-center " + activeClass,
                    onClick: (function (param) {
                        Curry._1(onClick, undefined);
                      })
                  }),
              className: "flex flex-wrap gap-2 text-sm mb-6 text-gray-600 font-medium cursor-pointer"
            });
}

var make = ChannelBadge;

exports.make = make;
/* react/jsx-runtime Not a pure module */
